// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__MljtQ","text":"styles_text__wLOk4","keyNumbers":"styles_keyNumbers__lv9T8"};